import styled from "styled-components"

export const DateContainer = styled.div`
  background-color: #fa4616;
  width: 115px;
  height: 104px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 8px 6px;
  gap: 1px;
  margin-top: 0px;

  @media (max-width: 768px) {
    width: 72px;
    height: 68px;
    padding: 8px;
    margin: ${props => (props.status === "published" ? "0" : "7px 0 7px 7px")};
  }
`

export const Day = styled.div`
  text-align: center;
  gap: 10px;
  width: 88px;
  height: 49px;
  background: #ffffff;
  border-radius: 5px;
  color: #000033;
  font-weight: 700;
  font-size: 2em;
  line-height: 40px;
  padding-top: 3.5px;

  @media (max-width: 768px) {
    padding: 2px 5px 0px;
    width: 50px;
    height: 32px;
    font-size: 1.125em;
    line-height: 24px;
  }
`

export const Date = styled.p`
  font-weight: 700;
  font-size: 2em;
  line-height: 40px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 1.125em;
    padding-left: 3px;
    line-height: 24px;
  }
`
